import React from "react";

/** One activity table on the admin dashboard. */
const AdminReservationTable = ({ title, icon, rows, onChangeTime, onDelete }) => (
  <section className="card">
    <h3>
      <span aria-hidden="true">{icon}</span> {title}
      <span className="chip ml-2">{rows.length} reservations</span>
    </h3>
    {rows.length === 0 ? (
      <div className="empty">
        <div className="big" aria-hidden="true">
          {icon}
        </div>
        <p>No reservations yet</p>
      </div>
    ) : (
      <div className="overflow-x-auto">
        <table className="table-dark">
          <thead>
            <tr>
              <th scope="col">Team</th>
              <th scope="col">Time</th>
              <th scope="col">People</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((reservation) => (
              <tr key={`${reservation.table_name}-${reservation.id}`}>
                <td>
                  <div className="font-semibold text-bone">{reservation.team_name}</div>
                  <div className="text-xs text-bone-dim">#{reservation.id}</div>
                </td>
                <td>
                  <button
                    type="button"
                    className="slot"
                    title="Change time slot"
                    onClick={() => onChangeTime(reservation)}
                  >
                    {reservation.time_slot}
                  </button>
                </td>
                <td>
                  <span className="chip agua">{reservation.team_number}</span>
                </td>
                <td>
                  <button type="button" className="btn btn-sm btn-danger" onClick={() => onDelete(reservation)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </section>
);

export default AdminReservationTable;
